import React from 'react';
import { ActivityIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section className="bg-brand-slate px-4 py-24 text-center text-white" data-id="element-62" data-mp="3n4wco9ljutno">
      <Reveal className="mx-auto max-w-3xl" data-id="element-63" data-mp="3s2xt0mrlcevg">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-brand-terracotta" data-id="element-64" data-mp="wem3iovl92f">
          <ActivityIcon className="h-7 w-7" aria-hidden="true" data-id="element-65" data-mp="2zeju84soheiu" />
        </div>
        <h2 className="mt-5 text-4xl font-black md:text-5xl" data-id="element-66" data-mp="34c27u8hn4hx6">
          Prêt à donner une nouvelle direction à vos cours de Reformer ?
        </h2>
        <p className="mx-auto mt-5 max-w-xl leading-relaxed text-white/80" data-id="element-67" data-mp="39adi2kbukufx">
          Rejoignez les professeurs qui enseignent déjà avec une progression complète, structurée et prête à l&apos;emploi.
        </p>
        <CTAButton className="mt-9 px-8 py-5 text-base md:text-lg" data-id="element-68" data-mp="2gkwr7r3vlllt">JE PRENDS PILATES REFORMER PRÊT</CTAButton>
        <p className="mt-4 text-xs font-semibold text-white/75" data-id="element-69" data-mp="2ljrb6wdkxg7i">
          Accès immédiat · Prêt à imprimer · Garantie 30 jours
        </p>
      </Reveal>
    </section>;
}